export const RECAPTHA_SITE_KEY = '6Ld-Ik4fAAAAAECWe8CGrHqBfHrt3bG64SA69Ep3';
export const API_BASE_URL = 'https://apisocial.stockedge.com';
